import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller for the macros dropdown on ticket show/index pages.
 * Handles opening the dropdown and submitting macro application.
 */
export default class extends Controller {
  static targets = ["dropdown", "menu"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle("hidden", !this.openValue)
    }

    if (this.openValue) {
      document.addEventListener("click", this.closeOnOutsideClick)
    } else {
      document.removeEventListener("click", this.closeOnOutsideClick)
    }
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }
}
